/*
 *	Service to interact with the backend API for fetching and updating contacts.
 *	Provides functions to get contacts, create new contacts, update existing contacts, and delete contacts.
 */

import { ContactData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
export const contactsApi = apiResource<ContactData>('contacts');
